import { Component, OnInit } from '@angular/core';
import { LookUpResourceModel } from '../../../../models/lookup-resource.model';
import { SectionWiseService } from '../../../../service/section-wise.service';
import { SwProcessPageUiService } from '../../../../service/ui/sw-process-page-ui.service';
import { SwProcessStateService } from '../../../../service/ui/sw-process-state.service';

@Component({
  selector: 'sw-discard-modal',
  templateUrl: './sw-discard-modal.component.html'
})
export class SwDiscardModalComponent implements OnInit {
  public isMainDiscard: boolean;

  constructor(
    private swProcessPageUiService: SwProcessPageUiService,
    private swProcessStateService: SwProcessStateService,
    private sectionWiseService: SectionWiseService
  ) {}
  public hasError = true;

  public closeDiscard(): void {
    this.swProcessPageUiService.closeSwDiscardModal({ isActive: false, isMainDiscard: this.isMainDiscard });
    this.sectionWiseService.setDiscardModalOpen(false);
  }

  ngOnInit() {
    this.swProcessPageUiService.isSwDiscardModalActive$.subscribe({
      next: (discardModal) => {
        this.isMainDiscard = discardModal.isMainDiscard;
      }
    });
  }

  public discardSwInput(): void {
    this.closeDiscard();
    if (this.isMainDiscard) {
      this.swProcessStateService.discardSwInput();
    } else {
      this.sectionWiseService.closeSwqModal(new LookUpResourceModel());
    }
  }
}
